import React from "react";

// Renders the official dark-mode logo (white text + red accent on black) at the
// requested height. No tile / background — the artwork already sits on black.
export default function BrandMark({ height = 56, className = "" }) {
  return (
    <img
      src="/assets/logo-dark.png"
      alt="Bharat Jeswani Consulting · Global AML Consultants"
      style={{ height }}
      className={`w-auto object-contain shrink-0 select-none ${className}`}
      draggable={false}
    />
  );
}
